import type { SxProps, Theme } from "@mui/material";

/** Cores da coluna Situação (mesmo padrão do grid mestre em scmanalyses). */
export const SITUACAO_CORES = {
  OK: {
    backgroundColor: "#90e5af",
    color: "#ffffff",
  },
  FALTA: {
    backgroundColor: "#eea499",
    color: "#ffffff",
  },
  INDEF: {
    backgroundColor: "#fffda6",
    color: "#000000",
  },
} as const;

export function getSituacaoCellSx(
  situacao?: string | null,
): SxProps<Theme> {
  const codigo = String(situacao ?? "").toUpperCase();

  if (codigo in SITUACAO_CORES) {
    return SITUACAO_CORES[codigo as keyof typeof SITUACAO_CORES];
  }

  return {};
}
